<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <div class="common-new-title mode2"><span>编辑时间轴-{{ thisTitle }}</span></div>
          <div class="this-tab-wrap">
            <el-tabs v-model="tabActive" type="card">
              <el-tab-pane :label="outerItem.monthName" v-for="(outerItem, outerIdx) in pageData" :key="outerIdx">
                <div class="this-content-wrap" v-for="(item, idx) in outerItem.stageList" :key="idx">
                  <span>{{ idx + 1 }}、</span>
                  <div class="form-area">
                    <div class="first-line">
                      <em>阶段名称：</em>
                      <el-input type="textarea" class="jm-input-common2" v-model="item.stageName" />
                      <em>阶段注释：</em>
                      <el-input type="textarea" class="jm-input-common2" v-model="item.stageNote" />
                      <em>阶段时间：</em>
                      <el-date-picker
                        v-model="item.stageTime"
                        class="jm-input-common2"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择时间">
                      </el-date-picker>
                    </div>
                    <div class="second-line">
                      <em>备注：</em>
                      <el-input
                        type="textarea"
                        :rows="6"
                        style="resize: none"
                        class="jm-input-common6"
                        placeholder="请输入"
                        v-model="item.stageMemo">
                      </el-input>
                    </div>
                  </div>
                  <div class="btn-area">
                    <el-button type="primary" v-if="outerItem.stageList.length > 1" @click="contentDelete(outerIdx, idx)">-</el-button>
                    <el-button type="primary" v-if="outerItem.stageList.length === idx + 1" @click="contentAdd(outerIdx)">+</el-button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="save-btn-area">
              <el-button type="primary" @click="pageSave">保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      thisTitle: '',
      thisId: '',
      tabActive: '0',
      pageData: [
        {
          monthName: '一月期',
          stageList: [
            {
              stageName: '', stageNote: '', stageTime: '', stageMemo: '', id: 0
            }
          ]
        }, {
          monthName: '四月期',
          stageList: [
            {
              stageName: '', stageNote: '', stageTime: '', stageMemo: '', id: 0
            }
          ]
        }, {
          monthName: '七月期方案一',
          stageList: [
            {
              stageName: '', stageNote: '', stageTime: '', stageMemo: '', id: 0
            }
          ]
        }, {
          monthName: '七月期方案二',
          stageList: [
            {
              stageName: '', stageNote: '', stageTime: '', stageMemo: '', id: 0
            }
          ]
        }, {
          monthName: '十月期',
          stageList: [
            {
              stageName: '', stageNote: '', stageTime: '', stageMemo: '', id: 0
            }
          ]
        },
      ],
    };
  },
  methods: {
    // 添加阶段
    contentAdd(outIdx) {
      let obj = {
        stageName: '',
        stageNote: '',
        stageTime: '',
        stageMemo: '',
      };
      this.pageData[outIdx].stageList.push(obj);
    },
    // 删除阶段
    contentDelete(outIdx, idx) {
      this.pageData[outIdx].stageList.splice(idx, 1);
    },
    // 保存
    pageSave() {
      this.$http._post({
        url: '/index/Study_planning/saveTimelineConfigration',
        data: { pageData: this.pageData, type: this.thisId }
      }).then((res) => {
        if (res.data === 1) {
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
      });
    },
    getTimeLineConfig(id) {
      this.$http._post({
        url: '/index/Study_planning/getTimeLineConfigration',
        data: { type: id }
      }).then((res) => {
        if (res.data.length > 0) {
          this.pageData = res.data;
        }
      });
    }
  },
  mounted() {
    this.thisTitle = this.$route.query.tname;
    this.thisId = this.$route.query.tid;
    this.getTimeLineConfig(this.thisId);
  },
  components: {
    'jm-crumbs': crumbs,
  },
};
</script>

<style scoped>
  .this-tab-wrap{
    padding-bottom: 20px;
  }
  .this-content-wrap{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 15px;
  }
  .this-content-wrap > span{
    line-height: 35px;
  }
  .this-content-wrap .form-area{
    margin: 0 10px;
  }
  .this-content-wrap .form-area em{
    margin: 0 10px;
    display: inline-block;
    vertical-align: top;
    line-height: 35px;
    min-width: 70px;
    text-align: right;
  }
  .this-content-wrap .form-area .first-line{
    margin-bottom: 15px;
  }
  .this-content-wrap .form-area .el-input{
    display: inline-block;
    vertical-align: top;
    min-width: 190px;
  }
  .this-content-wrap .form-area .el-textarea{
    width: 800px;
  }
  .this-content-wrap .btn-area{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 35px;
  }
  .this-content-wrap .btn-area .el-button{
    width: 20px;
    height: 20px;
    line-height: 20px;
    padding: 0;
    margin: 0 0 0 10px;
  }
  .save-btn-area{
    padding: 20px 0 20px 10px;
  }
</style>
